import { render, staticRenderFns } from "./ConsumoAgua.vue?vue&type=template&id=24a3ebce&scoped=true"
import script from "./ConsumoAgua.vue?vue&type=script&lang=js"
export * from "./ConsumoAgua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3ebce",
  null
  
)

export default component.exports